import { ref } from 'vue'
import { useQueue } from '../../composables/useQueue'
import { MessagesModel } from '../../models/MessagesModel'
import { Attachment } from '../../store/useMessages'

const USE_QUEUE = true

export const attachmentQueue = () => {
  const { queueError, queueSuccess, addToQueue } = useQueue({ networkRequired: true })
  const attachmentsToGrab = ref<Attachment[]>([])
  const addToDownloadAttachmentQueue = (data: Attachment[]) => {
    console.log('queue data', data)
    attachmentsToGrab.value = data
    if (USE_QUEUE) {
      void startAttachmentQueue()
    }
  }
  const startAttachmentQueue = async () => {
    for (const attachment of attachmentsToGrab.value) {
      console.log('queue:', attachment)
      const fn = async () => {
        const onDevice = await MessagesModel().attachmentOnDevice(attachment)
        if (!onDevice) {
          console.log(onDevice, `not on device, fetching ${attachment.name}`)
          await MessagesModel().downloadAttachment(
            {
              id: attachment.id,
              name: attachment.name,
              url: attachment.link,
            },
            true
          )
        } else {
          console.log('onDevice', attachment)
        }
      }
      await addToQueue([], fn)
        .then(() => {
          queueSuccess()
        })
        .catch(() => {
          queueError()
        })
    }
  }

  return {
    addToDownloadAttachmentQueue,
  }
}
